// <s-sticky-buy-bar> slides in on small screens once the main product form has scrolled above the viewport.
// Its button submits the real product form (same variant, quantity and add-to-cart handling).
class SStickyBuyBar extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.querySelector(this.dataset.target || '[data-product-form]');
    if (!target) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
    });
    this.inert = true;
    this.#observer.observe(target);
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-sticky-add]')) return;
    const form = document.querySelector('[data-product-form] form[action*="/cart/add"]');
    const submit = form?.querySelector('button[name="add"]');
    if (!form || !submit) {
      document.querySelector('[data-product-form]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    form.requestSubmit(submit);
  };
}

if (!customElements.get('s-sticky-buy-bar')) customElements.define('s-sticky-buy-bar', SStickyBuyBar);
